import { ContainerView } from './containerView.js';

class GridContainerView extends ContainerView {
	_containerElement = document.querySelector('.grid-container');

	_generateContainerMarkup() {
		return `
		<div class="grid-container">
			<section dir="rtl" class="main-letters"> 
			</section>
			<div class="pagination"></div>
		</div>`;
	}
}

export default new GridContainerView();
